(function(){
  var b=document.querySelector('.burger'),n=document.getElementById('mnav');
  if(b&&n){b.addEventListener('click',function(){var o=n.classList.toggle('open');b.setAttribute('aria-expanded',o?'true':'false');});}
  document.querySelectorAll('.yt button[data-yt]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var id=btn.getAttribute('data-yt'),t=btn.getAttribute('data-title')||'YouTube video';
      var f=document.createElement('iframe');
      f.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1';
      f.title=t;f.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';f.allowFullscreen=true;
      btn.parentNode.replaceChild(f,btn);
      var cap=f.parentNode.querySelector('.cap');if(cap)cap.remove();var p=f.parentNode.querySelector('.pbtn');if(p)p.remove();
    });
  });
})();
